<template>
    <span :data-toggle="isTruncated ? 'tooltip-text' : null"
          :data-original-title="isTruncated ? normalized : null"
          :data-placement="isTruncated ? 'top' : null"><template v-for="(line, i) in wrapped"><br v-if="i > 0" :key="'br' + i">{{ line }}</template></span>
</template>

<script>
// Odpowiednik layouts.site.parts.scalable-td dla Vue: tekst dluzszy niz line_max
// jest lamany co line_max znakow, a przy wrap_on_space cale wyrazy przechodza
// do nastepnej linii zamiast byc ciete (tabele maja text-nowrap, wiec <br> jest
// jedynym sposobem na zawiniecie komorki). Opcjonalny max_length przycina tekst
// do poczatku + "…" (jak truncated-text), a pelna tresc pokazuje tooltip.
import TableCellText from "../services/TableCellText";

const ELLIPSIS = '…';

export default {
    name: "WrappedText",
    props: {
        text: {default: ''},
        line_max: {type: [Number, String], required: true},
        wrap_on_space: {type: Boolean, default: true},
        max_length: {type: [Number, String], default: null},
        empty: {default: '-'}
    },
    computed: {
        normalized: function () {
            return TableCellText.normalize(this.text);
        },
        isTruncated: function () {
            return this.max_length !== null && this.normalized.length > parseInt(this.max_length, 10);
        },
        displayed: function () {
            if (!this.isTruncated) {
                return this.normalized;
            }

            return this.normalized.substring(0, parseInt(this.max_length, 10) - 1).trimEnd() + ELLIPSIS;
        },
        wrapped: function () {
            const lines = TableCellText.lines(this.displayed, parseInt(this.line_max, 10), this.wrap_on_space);

            return lines.length ? lines : [this.empty];
        }
    },
    beforeDestroy: function () {
        // dymek otwarty nad usuwanym wierszem zostalby w <body>
        const $el = $(this.$el);
        if ($el.data('bs.tooltip')) {
            $el.tooltip('dispose');
        }
    }
}
</script>
